import React from 'react';
import {TableCell, TableRow, TableHead, TableSortLabel, Checkbox } from '@mui/material';
import { trackActivity } from '../../../../utils/mixpanel';
import { PermissionWrapper } from '../../../../wrappers';

const ObligationsHd = ({ toggleBulkOps, item, createSortHandler, sortInfo, bulk }) => {

    const tableSorting = (key, name) => {
const handleItemClicked = (page_type) => {
		trackActivity('Item Clicked', { page_title: `Obligations`, page_type: page_type, })
	}
			return (
				<TableSortLabel
					active={sortInfo.sort_by === key ? true : false}
					direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
					onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
				>
					{name}
				</TableSortLabel>
			)
		}

    return (
       <TableHead>
			<TableRow>
				<TableCell className="table-actions-header">
					<PermissionWrapper extraProps={{ application: "lease_revamp", feature: "obligations", operationType: ['D'] }}>
						<Checkbox color='primary' size='small' onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
					</PermissionWrapper>
					Action(s)
				</TableCell>
				<TableCell sx={{ minWidth: '100px', whiteSpace: "nowrap" }}> {tableSorting('obligation_type', 'Type')}</TableCell>
				<TableCell sx={{ minWidth: '130px' }}> {tableSorting('sub_type', 'Sub Type')}</TableCell>
				{/* <TableCell sx={{ minWidth: '150px' }}> {tableSorting('currency', 'Currency')}</TableCell> */}
				<TableCell sx={{ minWidth: '150px' }}> {tableSorting('value', 'Commercial Value')}</TableCell>
				<TableCell sx={{ minWidth: '160px' }}> {tableSorting('details', 'Details')}</TableCell>
				<TableCell sx={{ minWidth: '120px' }}> {tableSorting('status', 'Status')}</TableCell>
				<TableCell sx={{ minWidth: '130px' }}> {tableSorting('applicable', 'Applicable To')}</TableCell>
				<TableCell sx={{ minWidth: '150px' }}> {tableSorting('to_be_approved_by', 'Approver')}</TableCell>
				<TableCell sx={{ minWidth: '130px' }}> {tableSorting('payment_due_date', 'Due Date')}</TableCell>
				<TableCell sx={{ minWidth: '130px' }}> {tableSorting('frequency', 'Frequency')}</TableCell>
				<TableCell sx={{ minWidth: '130px' }}> {tableSorting('copies', 'Copies')}</TableCell>
				<TableCell sx={{ minWidth: '130px' }}> {tableSorting('guarantor', 'Guarantor')}</TableCell>
				<TableCell sx={{ minWidth: '130px' }}> {tableSorting('required', 'Required')}</TableCell>
				<TableCell sx={{ minWidth: '160px' }}> {tableSorting('remarks', 'Remarks')}</TableCell>
			</TableRow>
		</TableHead>
    );
};

export default ObligationsHd;
